export default __webpack_public_path__ + "static/media/wm2.cfb7fda7.jpg";